import React from "react";

const paths = {
  activation: (
    <>
      <path d="M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
      <path d="M2.5 21a5.5 5.5 0 0 1 11 0" />
      <path d="m16 11 2 2 4-5" />
    </>
  ),
  engagement: (
    <>
      <path d="M4 6.5A3.5 3.5 0 0 1 7.5 3h9A3.5 3.5 0 0 1 20 6.5v4A3.5 3.5 0 0 1 16.5 14H12l-4.5 4v-4A3.5 3.5 0 0 1 4 10.5v-4Z" />
      <path d="M8 8h8" />
      <path d="M8 11h5" />
    </>
  ),
  claims: (
    <>
      <path d="M7 3h8l4 4v14H7V3Z" />
      <path d="M15 3v5h4" />
      <path d="M10 12h6" />
      <path d="M10 16h4" />
    </>
  ),
  value: (
    <>
      <path d="M12 3v18" />
      <path d="M16 6.5H9.5a2.5 2.5 0 0 0 0 5H14a2.5 2.5 0 0 1 0 5H7" />
      <path d="M18 4h3v3" />
      <path d="m21 4-5 5" />
    </>
  ),
  split: (
    <>
      <path d="M12 3v5" />
      <path d="M6 13a6 6 0 0 1 12 0" />
      <path d="M5 21a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
      <path d="M19 21a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
    </>
  ),
  status: (
    <>
      <path d="M5 5h14" />
      <path d="M5 12h14" />
      <path d="M5 19h14" />
      <path d="M7 3v4" />
      <path d="M15 10v4" />
      <path d="M11 17v4" />
    </>
  ),
  relationship: (
    <>
      <path d="M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
      <path d="M16 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
      <path d="M3 20a5 5 0 0 1 10 0" />
      <path d="M11 20a5 5 0 0 1 10 0" />
    </>
  ),
  trends: (
    <>
      <path d="M4 19V5" />
      <path d="M4 19h16" />
      <path d="m7 15 4-4 3 3 5-7" />
      <path d="M17 7h2v2" />
    </>
  ),
  table: (
    <>
      <path d="M4 5h16v14H4V5Z" />
      <path d="M4 10h16" />
      <path d="M4 15h16" />
      <path d="M10 5v14" />
    </>
  ),
};

const toneClassMap = {
  brand: "border-blue-200 bg-blue-100 text-blue-700",
  success: "border-emerald-200 bg-emerald-100 text-emerald-700",
  warning: "border-amber-200 bg-amber-100 text-amber-700",
  accent: "border-violet-200 bg-violet-100 text-violet-700",
  neutral: "border-gray-300 bg-gray-100 text-gray-700",
};

const sizeClassMap = {
  sm: "h-5 w-5 rounded-md p-1",
  md: "h-6 w-6 rounded-md p-1.5",
  metric: "h-10 w-10 rounded-md p-2",
};

const OpdIcon = ({
  name = "claims",
  className = "",
  title = "",
  tone = "brand",
  size = "md",
}) => (
  <span
    className={`inline-flex shrink-0 items-center justify-center border ${sizeClassMap[size] || sizeClassMap.md} ${toneClassMap[tone] || toneClassMap.brand} ${className}`}
    aria-hidden={title ? undefined : "true"}
    title={title}
  >
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {paths[name] || paths.claims}
    </svg>
  </span>
);

export default OpdIcon;
